var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Rectangle-1908",on:{"click":_vm.textClicked}},[_c('div',{staticClass:"text-container"},[_c('ProcessedPostText',{attrs:{"readMoreColor":"white","content":_vm.content}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }